import type { ShapeData } from '@/lib/shapes/types/shape-data'
import type { TextBoxData } from '@/lib/text/types/text-box-data'
import {
  isShapeUnderFrozenGroupAncestor,
  isTextUnderFrozenGroupAncestor,
} from '@/lib/groups/element-edit-policy'

/**
 * Whether any of these shapes or text frames sits under a frozen group, resolved against the live
 * shape list. Delete and Cut both refuse such a child inside group isolation.
 */
export function selectionHasChildUnderFrozenGroup(
  shapes: readonly ShapeData[],
  textBoxes: readonly TextBoxData[],
  allShapes: readonly ShapeData[]
): boolean {
  const shapesById = new Map(allShapes.map((shape) => [shape.id, shape]))

  return (
    shapes.some((shape) => isShapeUnderFrozenGroupAncestor(shape, shapesById)) ||
    textBoxes.some((box) => isTextUnderFrozenGroupAncestor(box, shapesById))
  )
}
